document.addEventListener('DOMContentLoaded', () => {
	const  debounce = (func, wait = 1000) => {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func(...args), wait);
		};
	};

	const changeQty = e => {
		const { target } = e;
		const { max } = target;
		if (Number(target.value) > Number(max)) {
			target.value = max;
		}
	}

	for (const qty of [...document.querySelectorAll('[data-quantity-input]')]) {
		qty.addEventListener('change', debounce(changeQty));
		qty.addEventListener('input', debounce(changeQty));
	}
});